import React, { ChangeEventHandler } from 'react'

import { styled } from 'styled-components'

import { useUser } from '../../context'
import { capitalizeFirstLetter } from '../../utilFunctions/transformFunc'

export const Select = styled.select`
  border-radius: 12px;
  border: none;
  padding: 10px 12px;
  font-size: 14px;
  outline: none;
  color: #8e92bc;
  background: transparent;
  border: 1px solid #dbdbdb;
  width: 100%;

  &:disabled {
    color: #0a0a18;
    background: #f6f6f6;
    border: none;
  }

  &:active,
  &:focus,
  &:hover {
    border: 1px solid #08a8d2;
  }
`

const FormSelect = ({
  id,
  value,
  onChangeFn,
  opts,
  className,
}: {
  id: string
  value: string
  onChangeFn: ChangeEventHandler<HTMLSelectElement>
  opts?: string[]
  className?: string
}) => {
  const { onEditionMode } = useUser()
  return (
    <Select
      name={id}
      value={value}
      onChange={onChangeFn}
      id={id}
      disabled={!onEditionMode}
      className={className}
    >
      {opts &&
        opts.map((opt) => (
          <option value={opt} key={`${id}-${opt}`}>
            {capitalizeFirstLetter(opt)}
          </option>
        ))}
    </Select>
  )
}

export default FormSelect
